import React from "react";
import { useParams, NavLink } from "react-router-dom";
import titleize from "underscore.string/titleize";
import EditForm from "../components/company/EditForm";
import {
  Layouts, 
  Loaders,
} from "../components";
import { useCompany } from "../queries/company";

function CompanyEdit() {
  let { company_id } = useParams()
  const {data:company, isLoading } = useCompany({company_id})

  if(isLoading)
    return <Loaders.SpacedPageLoader />
  
  return(
    <div className="bg-white mvh-100">
      <Layouts.PageHeader left={`Edit ${titleize(company.name)}`} />
      <div className="overview-content">
        <div className="nav-tabs-container">
          <ul className="nav nav-tabs dark px-3" role="tablist">
            <li className="nav-item">
              <NavLink to="company-overview" className="nav-link active" data-bs-toggle="tab" data-bs-target="#company-overview" role="tab">Overview</NavLink>
            </li>
          </ul>
        </div>
        <div className="tab-content px-3 pt-3 pb-5">
          <div className="tab-pane fade show active" id="pitch-editor" role="tabpanel">
            <div className="company-form">
              <EditForm company={company}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompanyEdit;